import React from 'react';
import Typography from '@mui/material/Typography';
import styles from './Feature.module.scss';
import {Slide} from "react-awesome-reveal";

interface FeaturesProps {
    title: React.ReactNode;
    content: React.ReactNode;
    img: string;
    direction?: 'left' | 'right';
}

const Features: React.FC<FeaturesProps> = ({ title, content, img, direction }) => {
    let imageStyle = undefined
    return (
        <Slide direction={direction}>
        <div className={`${styles.feature} ${direction! === 'right' ? styles.right : styles.left}`}>
                <img src={img} alt={typeof title === 'string' ? title : 'Feature image'}/>
                <div className={styles.cardContent}>
                    <div className={styles.title}>
                        {typeof title === 'string' ? (
                            <Typography variant="h4" component="div">
                                {title}
                            </Typography>
                        ) : (
                            title
                        )}
                    </div>
                    <div className={styles.content}>
                        {typeof content === 'string' ? (
                            <p>
                                {content}
                            </p>
                        ) : (
                            content
                        )}
                    </div>
                </div>
            </div>
        </Slide>
            );
            };

            export default Features;